module.exports = __webpack_public_path__ + "img/mobile_product3.281b23bf.png";